import { Component, OnInit, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';


export interface DialogData {
  title: string;
  question: string;
}

@Component({
  selector: 'app-overview-dialog',
  templateUrl: './overview-dialog.component.html'
})
export class OverviewDialogComponent implements OnInit {
  title: string;
  question: string;

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: DialogData,
    @Optional() public dialogRef: MatDialogRef<OverviewDialogComponent>
  ) {
    if (data) {
      this.title = data.title;
      this.question = data.question;
    }
  }

  clickSi() {
    this.dialogRef.close('Sí');
  }

  clickNo() {
    this.dialogRef.close('No');
  }

  ngOnInit() {
  }

}
